<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :get-data-func="getBillList"
      title-text="用户钱包列表"
      @click:row="getDetails($event.item)"
      clickable
      :headers="header"
    >
    </l-data-table>
  </l-layout>
</template>

<script>
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
export default {
  name: "billList",
  components: { LDataTable },
  data() {
    return {
      header: [
        { text: "用户名称", value: "userId", sortable: true, align: "left" },
        { text: "钱包余额", value: "balance", sortable: false, align: "left" },
      ],
    };
  },
  methods: {
    async getBillList({ pagination, sortStack, filterItems = [], search }) {
      let { items, amount } = await this.$store.dispatch("pay/getUserInfo", {
        search: { key: "userId", value: search },
        pagination,
        filter: filterItems,
      });
      console.log(items);
      return { items: items, amount: amount };
    },
    getDetails(item) {
      let selectionString = document.getSelection().toString();
      if (!selectionString) {
        this.$router.push({
          name: "userWalletDetailBox",
          query: { userId: item.userId },
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
